import * as types from "../actions/actionTypes";

export function fetchProductFeedIssueReducer(
    state = {
      message: "",
    },
    action
  ) {
    switch (action.type) {
      case types.FETCH_PRODUCT_FEED_ISSUE_REQUESTED:
        return Object.assign({}, state, {
          message: "FETCH_PRODUCT_FEED_ISSUE_REQUESTED",
        });
      case types.FETCH_PRODUCT_FEED_ISSUE_RECEIVED:
        let { data } = action;
        return Object.assign({}, state, {
          ...action.data,
          message: "FETCH_PRODUCT_FEED_ISSUE_RECEIVED",
        });
      case types.FETCH_PRODUCT_FEED_ISSUE_FAILED:
        return Object.assign({}, state, {
          message: "FETCH_PRODUCT_FEED_ISSUE_FAILED",
        });
      default:
        // console.log("The state is Connections Data= ", state);
        return state;
    }
  }